var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNhnsolution1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.2606 50.1274H18.0945C15.557 50.1274 13.5 52.1528 13.5 54.6513V60.6084C13.5 63.1068 15.557 65.1322 18.0945 65.1322H53.2606C55.7981 65.1322 57.8551 63.1068 57.8551 60.6084V54.6513C57.8551 52.1528 55.7981 50.1274 53.2606 50.1274Z",
    fill: "#1681FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2606 50.1274H18.0945C15.557 50.1274 13.5 52.1528 13.5 54.6513V60.6084C13.5 63.1068 15.557 65.1322 18.0945 65.1322H53.2606C55.7981 65.1322 57.8551 63.1068 57.8551 60.6084V54.6513C57.8551 52.1528 55.7981 50.1274 53.2606 50.1274Z",
    fill: "url(#paint0_linear_2137_19202)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2606 35.1226H18.0945C15.557 35.1226 13.5 37.1479 13.5 39.6464V45.6035C13.5 48.1019 15.557 50.1273 18.0945 50.1273H53.2606C55.7981 50.1273 57.8551 48.1019 57.8551 45.6035V39.6464C57.8551 37.1479 55.7981 35.1226 53.2606 35.1226Z",
    fill: "url(#paint1_linear_2137_19202)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2606 20.1182H18.0945C15.557 20.1182 13.5 22.1435 13.5 24.642V30.5991C13.5 33.0975 15.557 35.1229 18.0945 35.1229H53.2606C55.7981 35.1229 57.8551 33.0975 57.8551 30.5991V24.642C57.8551 22.1435 55.7981 20.1182 53.2606 20.1182Z",
    fill: "url(#paint2_linear_2137_19202)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0183 24.7095H37.229C36.4262 24.7095 35.7754 25.3603 35.7754 26.1631C35.7754 26.966 36.4262 27.6168 37.229 27.6168H50.0183C50.8211 27.6168 51.4719 26.966 51.4719 26.1631C51.4719 25.3603 50.8211 24.7095 50.0183 24.7095Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0396 24.7095H29.2603C28.4575 24.7095 27.8066 25.3603 27.8066 26.1631C27.8066 26.966 28.4575 27.6168 29.2603 27.6168H32.0396C32.8425 27.6168 33.4933 26.966 33.4933 26.1631C33.4933 25.3603 32.8425 24.7095 32.0396 24.7095Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0178 40.0762H37.229C36.4262 40.0762 35.7754 40.727 35.7754 41.5298C35.7754 42.3327 36.4262 42.9835 37.229 42.9835H50.0178C50.8206 42.9835 51.4715 42.3327 51.4715 41.5298C51.4715 40.727 50.8206 40.0762 50.0178 40.0762Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0178 54.3208H37.229C36.4262 54.3208 35.7754 54.9716 35.7754 55.7745C35.7754 56.5773 36.4262 57.2281 37.229 57.2281H50.0178C50.8206 57.2281 51.4715 56.5773 51.4715 55.7745C51.4715 54.9716 50.8206 54.3208 50.0178 54.3208Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0088 38.2915C62.627 38.2915 68.8028 32.2107 68.8028 24.7097C68.8028 17.2087 62.627 11.1279 55.0088 11.1279C47.3906 11.1279 41.2148 17.2087 41.2148 24.7097C41.2148 32.2107 47.3906 38.2915 55.0088 38.2915Z",
    fill: "url(#paint3_linear_2137_19202)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0088 38.2915C62.627 38.2915 68.8028 32.2107 68.8028 24.7097C68.8028 17.2087 62.627 11.1279 55.0088 11.1279C47.3906 11.1279 41.2148 17.2087 41.2148 24.7097C41.2148 32.2107 47.3906 38.2915 55.0088 38.2915Z",
    fill: "url(#paint4_linear_2137_19202)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60.062 27.1106C60.062 24.3698 57.7974 22.1536 55.0092 22.1762C54.1915 22.1808 53.5255 21.534 53.5255 20.7289C53.5255 19.9239 54.1915 19.2636 55.0092 19.259C55.8268 19.2545 56.4929 19.9013 56.4929 20.7063L59.033 20.6882C59.033 18.7208 57.5677 17.1017 55.6568 16.8077V15.2563L54.3615 15.2654V16.8167C52.4506 17.1378 50.9853 18.7796 50.9853 20.747C50.9853 22.9315 52.7905 24.6954 55.0092 24.6773C56.3918 24.6683 57.5172 25.7673 57.5172 27.1287C57.5172 28.4901 56.3918 29.6072 55.0092 29.6162C53.6265 29.6253 52.5011 28.5262 52.5011 27.1649L49.9609 27.183C49.9609 29.7067 51.8856 31.7827 54.3615 32.0766V33.5692L55.6568 33.5601V32.0676C58.1373 31.7329 60.0574 29.6343 60.0574 27.1061L60.062 27.1106Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2137_19202",
    x1: 36.6776,
    y1: 47.1274,
    x2: 2.87439,
    y2: 52.0265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1681FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D4D96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2137_19202",
    x1: 57.8551,
    y1: 41.1249,
    x2: 15.5,
    y2: 41.1249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2137_19202",
    x1: 36.6776,
    y1: 17.1182,
    x2: 2.87439,
    y2: 22.0173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1681FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D4D96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2137_19202",
    x1: 55.0088,
    y1: 11.1279,
    x2: 32.6164,
    y2: 12.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1681FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D4D96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2137_19202",
    x1: 74.369,
    y1: 24.7097,
    x2: 41.2148,
    y2: 24.7097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E3E3E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNhnsolution1);
export default __webpack_public_path__ + "static/media/nhnsolution1.99b18926906554b7a59da0cee568ab3e.svg";
export { ForwardRef as ReactComponent };